import React from 'react';
import './LayoutSection.css';

const LayoutSection = () => {
  return (
    <section className="layout-section">
      <div className="layout-container">
        <h2 className="layout-heading">Site Plan</h2>
        <div className="layout-image-wrapper">
          <img src="/layout.png" alt="Property Layout" className="layout-image" />
        </div>
      </div>
    </section>
  );
};

export default LayoutSection;

